const cueSet2 = [
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 0,
        "time": 0,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 15360,
        "time": 0.5882350000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 30720,
        "time": 1.1764700000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 46080,
        "time": 1.7647050000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 61440,
        "time": 2.3529400000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 76800,
        "time": 2.9411750000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 92160,
        "time": 3.5294100000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 107520,
        "time": 4.117645,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 122880,
        "time": 4.7058800000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 138240,
        "time": 5.294115000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 153600,
        "time": 5.882350000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 168960,
        "time": 6.470585000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 184320,
        "time": 7.128708,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 199680,
        "time": 7.647055000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 215040,
        "time": 8.23529,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 230400,
        "time": 8.823525,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 245760,
        "time": 9.411760000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 261120,
        "time": 9.999995000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 276480,
        "time": 10.588230000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 291840,
        "time": 11.176465,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 307200,
        "time": 11.764700000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 322560,
        "time": 12.352935000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 337920,
        "time": 12.941170000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 353280,
        "time": 13.529405,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 368640,
        "time": 14.257416,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 384000,
        "time": 14.705875000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999992,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 399360,
        "time": 15.294110000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 414720,
        "time": 15.882345,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 430080,
        "time": 16.47058,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 445440,
        "time": 17.058815000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 460800,
        "time": 17.64705,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 476160,
        "time": 18.235285,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 491520,
        "time": 18.823520000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 506880,
        "time": 19.411755000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 522240,
        "time": 19.999990000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 537600,
        "time": 20.588225,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 552960,
        "time": 21.386124,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 568320,
        "time": 21.764695000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 583680,
        "time": 22.35293,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 599040,
        "time": 22.941165,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 614400,
        "time": 23.529400000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 629760,
        "time": 24.117635000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 645120,
        "time": 24.705870000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 660480,
        "time": 25.294105000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 675840,
        "time": 25.882340000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 691200,
        "time": 26.470575000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 706560,
        "time": 27.05881,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 721920,
        "time": 27.647045000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 737280,
        "time": 28.514832,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 752640,
        "time": 28.823515000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 768000,
        "time": 29.411750000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 783360,
        "time": 29.999985000000002,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.588235000000001,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 798720,
        "time": 30.588220000000003,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 814080,
        "time": 31.176455000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 829440,
        "time": 31.76469,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 844800,
        "time": 32.352925000000006,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 860160,
        "time": 32.94116,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 875520,
        "time": 33.529395,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 890880,
        "time": 34.117630000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 906240,
        "time": 34.705865,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 921600,
        "time": 35.64354,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 936960,
        "time": 35.882335000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 952320,
        "time": 36.47057,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 967680,
        "time": 37.05880500000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 983040,
        "time": 37.647040000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 998400,
        "time": 38.235275,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1013760,
        "time": 38.823510000000006,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1029120,
        "time": 39.411745,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1044480,
        "time": 39.99998000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1059840,
        "time": 40.588215000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 1075200,
        "time": 41.17645,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 1090560,
        "time": 41.76468500000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1105920,
        "time": 42.772248,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1121280,
        "time": 42.941155,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1136640,
        "time": 43.52939000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1152000,
        "time": 44.117625000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1167360,
        "time": 44.70586,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 55,
        "name": "G3",
        "ticks": 1182720,
        "time": 45.294095000000006,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 1198080,
        "time": 45.88233,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 1213440,
        "time": 46.47056500000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 1228800,
        "time": 47.058800000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 51,
        "name": "D#3",
        "ticks": 1244160,
        "time": 47.647035,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1259520,
        "time": 48.23527000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 48,
        "name": "C3",
        "ticks": 1274880,
        "time": 48.823505000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1290240,
        "time": 49.900956,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1305600,
        "time": 49.999975000000006,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1320960,
        "time": 50.588210000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1336320,
        "time": 51.17644500000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1351680,
        "time": 51.764680000000006,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1367040,
        "time": 52.352915,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1382400,
        "time": 52.94115000000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 50,
        "name": "D3",
        "ticks": 1397760,
        "time": 53.529385000000005,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1413120,
        "time": 54.11762,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 58,
        "name": "A#3",
        "ticks": 1428480,
        "time": 54.70585500000001,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882350000000045,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 1443840,
        "time": 55.294090000000004,
        "velocity": 0.7874015748031497
    },
    {
        "duration": 0.5882349999999974,
        "durationTicks": 15360,
        "midi": 43,
        "name": "G2",
        "ticks": 1459200,
        "time": 55.88232500000001,
        "velocity": 0.7874015748031497
    }
];

export default cueSet2;